import { z } from "zod";
import { baseEntityFields, customFieldsField } from "./base.js";

/** Champs metier de la famille voucher (hors champs standard du socle). */
export const voucherCoreFields = {
  orgId: z.string(),
  /** Discriminant de sous-type declare par l'app (ex. "montant", "avantage", "contremarque"). */
  type: z.string().min(1),
  /** Code unique porteur de la valeur / de l'avantage. Coeur de la famille, requis. */
  code: z.string().min(1),
  /** Valeur initiale chargee sur le titre (montant). Optionnel (un avantage n'a pas toujours de valeur). */
  initialValue: z.number().optional(),
  /** Solde restant utilisable (montant). Optionnel. */
  remainingValue: z.number().optional(),
  /** Date d'expiration du titre. Optionnel. */
  expiresAt: z.date().optional(),
  /** Fiche contact a qui le titre a ete emis. Optionnel (titre transmissible, souvent au porteur). */
  issuedToContactId: z.string().min(1).optional(),
  /** Ids des pieces ou le titre a ete utilise (payment, order, credit). Optionnel. */
  redeemedRefs: z.array(z.string()).optional(),
  // Securite : famille staff-only, org-wide en v0 (meme doctrine qu'asset). Les codes ne sont JAMAIS listables depuis un portail client : la validation d'un code (redeem) passera par une fonction serveur, hors v0.
} as const;

export const VoucherSchema = z.object({ ...baseEntityFields, ...voucherCoreFields });
export type Voucher = z.infer<typeof VoucherSchema>;
export const VoucherCreateInputSchema = z.object({
  ...voucherCoreFields,
  ...customFieldsField,
});
export type VoucherCreateInput = z.infer<typeof VoucherCreateInputSchema>;

/**
 * Schema du patch de mise a jour (update partiel).
 * `orgId` et `type` sont immuables (Security Rules) ; les champs standard
 * sont geres par le SDK : aucun des deux n'est accepte ici.
 */
export const VoucherUpdateInputSchema = z
  .object({ ...voucherCoreFields, ...customFieldsField })
  .omit({ orgId: true, type: true })
  .partial();

/** Type du patch de mise a jour d'un voucher. */
export type VoucherUpdateInput = z.infer<typeof VoucherUpdateInputSchema>;
